<template>
    <div>
        <div class="columns">
            <div class="column is-12 is-offset-0 is-10-widescreen is-offset-1-widescreen is-8-fullhd is-offset-2-fullhd">
                <div class="box has-background-white-bis" v-if="step === 1">
                    <div class="field">
                        <label class="label" :class="'has-text-' + secondaryColor">{{ $t('vue.vouchers.email') }}</label>
                        <div class="control has-icons-left">
                            <input
                                :class="{'is-danger': errors.email}"
                                class="input"
                                type="text"
                                name="email"
                                v-model="values.email"
                            />
                            <span class="icon is-small is-left"><i class="fas fa-at"></i></span>
                        </div>
                        <p class="help is-danger" v-if="errors.email">{{ errors.email }}</p>
                        <p class="help" v-else>{{ $t('vue.vouchers.emailHelp') }}</p>
                    </div>
                    <div class="field">
                        <label class="label" :class="'has-text-' + secondaryColor">{{ $t('vue.vouchers.inscription') }}</label>
                        <div class="control has-icons-left">
                            <input
                                :class="{'is-danger': errors.inscription}"
                                class="input"
                                type="text"
                                name="inscription"
                                v-model="values.inscription"
                            />
                            <span class="icon is-small is-left"><i class="fas fa-pen"></i></span>
                        </div>
                        <p class="help is-danger" v-if="errors.inscription">{{ errors.inscription }}</p>
                        <p class="help" v-else>{{ $t('vue.vouchers.inscriptionHelp') }}</p>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <label class="label" :class="'has-text-' + secondaryColor">{{ $t('vue.vouchers.voucherValue') }}</label>
                            <div class="field" v-for="voucherValue in voucherValues">
                                <input class="is-checkradio" :class="'is-' + secondaryColor" :id="'voucher_value_' + voucherValue" type="radio" v-model="values.voucher_value" v-bind:value="voucherValue">
                                <label :for="'voucher_value_' + voucherValue">{{ voucherValue}} Kč</label>
                            </div>
                            <p class="help is-danger" v-if="errors.voucher_value">{{ errors.voucher_value }}</p>
                        </div>
                        <div class="column">
                            <label class="label" :class="'has-text-' + secondaryColor">{{ $t('vue.vouchers.paymentMethod') }}</label>
                            <div class="field" v-for="paymentMethod in paymentMethods" :key="paymentMethod.id">
                                <input class="is-checkradio" :class="'is-' + secondaryColor"  :id="'web_payment_method_id_' + paymentMethod.id" type="radio" v-model="values.web_payment_method_id" v-bind:value="paymentMethod.id">
                                <label :for="'web_payment_method_id_' + paymentMethod.id">{{ $t('vue.vouchers.paymentMethods.' + paymentMethod.type) }}</label>
                            </div>
                            <p class="help is-danger" v-if="errors.web_payment_method_id">{{ errors.web_payment_method_id }}</p>
                        </div>
                    </div>
                    <label class="checkbox">
                      <input type="checkbox" v-model="values.newsletter" />
                      {{ $t('vue.newsletter') }}
                    </label>
                    <div class="columns pt-5">
                        <div class="column has-text-centered">
                            <a class="voucher-form__button button is-success" :class="{'is-loading': loading}" @click="check">{{ $t('vue.continue') }}</a>
                        </div>
                    </div>
                </div>
                <div class="box has-background-white-bis" v-if="step === 2">
                    <h2 class="title is-4 has-text-centered" :class="'has-text-' + secondaryColor">{{ $t('vue.vouchers.recapitulation') }}</h2>
                    <hr />
                    <div class="content">
                        <p>
                            {{ $t('vue.vouchers.deliveryEmail') }}: <strong>{{ values.email }}</strong>
                        </p>
                        <p v-if="values.inscription">
                            {{ $t('vue.vouchers.inscription') }}: <strong>{{ values.inscription }}</strong>
                        </p>
                        <p>
                            {{ $t('vue.vouchers.voucherValue') }}: <strong>{{ values.voucher_value }} Kč</strong>
                        </p>
                        <p>
                            {{ $t('vue.vouchers.paymentMethod') }}: <strong>{{ paymentValue }}</strong>
                        </p>
                        <p>
                          {{ $t('vue.newsletter') }}: <strong>{{ values.newsletter ? $t('vue.Yes') : $t('vue.No') }}</strong>
                        </p>
                        <hr />
                        <p class="has-text-centered">{{ $t('vue.vouchers.isOk') }}</p>
                    </div>
                    <div class="columns">
                        <div class="column has-text-right has-text-centered-mobile">
                            <a class="voucher-form__button button is-info" @click="step = 1">{{ $t('vue.back') }}</a>
                        </div>
                        <div class="column has-text-left has-text-centered-mobile">
                            <a class="voucher-form__button button is-warning" :class="{'is-loading': loading}" @click="checkout">
                                {{ instantPayment ? $t('vue.vouchers.pay') : $t('vue.vouchers.order') }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: "GiftCouponForm",
        props: {
            checkUrl: String,
            checkoutUrl: String,
            paymentMethods: Array,
            secondaryColor: String,
            voucherValues: Array,
        },
        data() {
            return {
                values: {
                    email: '',
                    inscription: '',
                    voucher_value: null,
                    web_payment_method_id: null,
                    newsletter: false,
                },
                errors: {
                    email: null,
                    inscription: null,
                    voucher_value: null,
                    web_payment_method_id: null,
                },
                step: 1,
                loading: false,
            }
        },
        computed: {
            paymentValue()
            {
                let values = this.values;
                let paymentMethod = this.paymentMethods.find(function(paymentMethod) {
                    return paymentMethod.id === values.web_payment_method_id;
                });
                if (!paymentMethod) {
                    return false;
                }
                return this.$t('vue.vouchers.paymentMethods.' + paymentMethod.type);
            },
            instantPayment() {
                let values = this.values;
                let paymentMethod = this.paymentMethods.find(function(paymentMethod) {
                    return paymentMethod.id === values.web_payment_method_id;
                });
                if (!paymentMethod) {
                    return false;
                }
                return paymentMethod.instant;
            }
        },
        methods: {
            check() {
                this.loading = true;
                this.clearErrors();
                axios.post(this.checkUrl, this.values).then((response) => {
                    this.step = 2;
                    this.loading = false;
                }).catch((error) => {
                    let errors = error.response.data.errors;
                    this.errors.email = errors.email ? errors.email[0] : null;
                    this.errors.inscription = errors.inscription ? errors.inscription[0] : null;
                    this.errors.voucher_value = errors.voucher_value ? errors.voucher_value[0] : null;
                    this.errors.web_payment_method_id = errors.web_payment_method_id ? errors.web_payment_method_id[0] : null;
                    this.loading = false;
                });
            },
            checkout() {
                this.loading = true;
                axios.post(this.checkoutUrl, this.values).then((response) => {
                    window.location.href = response.data.url;
                }).catch((error) => {
                    this.step = 1;
                    this.loading = false;
                });
            },
            clearErrors() {
                this.errors.email = null;
                this.errors.inscription = null;
                this.errors.voucher_value = null;
                this.errors.web_payment_method_id = null;
            }
        }
    }
</script>

<style lang="sass">
    .voucher-form__button
        width: 10rem
</style>
